/**
* What It Treats JS
* -----------------------------------------------------------------------------
*
* All the JS for the What It Treats component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {
    className: 'what-it-treats',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const toggleButton = document.querySelector( '.view-more-toggle' );

      if ( !toggleButton ) {
        // console.error( 'Element \'.view-more-toggle\' not found.' );
        return;
      }

      toggleButton.addEventListener( 'click', function() {
        const hiddenItems = document.querySelectorAll( '.concern-item' );
        const isExpanded = this.getAttribute( 'data-show' ) === 'true';

        hiddenItems.forEach( ( item, index ) => {
          if ( index >= 11 ) {
            item.classList.toggle( 'hidden', isExpanded );
            item.style.display = isExpanded ? 'none' : 'flex';
          }
        } );

        this.innerHTML = isExpanded ?
          'View More <span class="arrow"><svg class="w-4 h-4 ml-3 shrink-0 icon icon-chevron-down"><use xlink:href="#icon-chevron-down"></use></svg></span>' :
          'View Less <span class="arrow"><svg class="w-4 h-4 ml-3 shrink-0 icon icon-chevron-up"><use xlink:href="#icon-chevron-up"></use></svg></span>';

        this.setAttribute( 'data-show', !isExpanded );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'what-it-treats', COMPONENT );
} )( app );
